import { RefreshCcw, TriangleAlert } from 'lucide-react';

import { Button } from '../../atoms/new-button';

interface ErrorPageProps {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
}

export const ErrorPage = ({ title, description }: ErrorPageProps) => {
  return (
    <div className="flex w-full justify-center px-4 pt-36">
      <div className="relative max-w-md rounded-xl border border-gray-200 bg-white p-8 text-center shadow-lg">
        {/* Background decorative element */}
        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-red-50 to-orange-50 opacity-50"></div>

        {/* Content */}
        <div className="relative flex flex-col items-center gap-6">
          {/* Icon with enhanced styling */}
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-yellow-100">
            <TriangleAlert className="h-10 w-10 text-yellow-600" />
          </div>

          {/* Text content */}
          <div className="flex flex-col items-center gap-3">
            <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>
            <div className="leading-relaxed text-gray-500">{description}</div>
          </div>
          {/* Refresh button */}
          <Button variant="primary" onClick={() => window.location.reload()} size="sm">
            Refresh <RefreshCcw />
          </Button>
        </div>
      </div>
    </div>
  );
};
